import { ToastWarn, ToastSuccess } from "../../commonComponents/ToastHelper";

// FIREBASE
import { getFunctions, httpsCallable } from "firebase/functions";
import { doc, getDoc, getDocs, setDoc, collection, updateDoc, query, where } from "firebase/firestore";
import firebase from "../../firebase/config";
import { db_firestore, auth } from "../../firebase/config";
import { ListItemButton } from "@mui/material";

export const fetchUserInfo = () => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[FETCH_USER_INFO]");
    const userRef = doc(db_firestore, "users", auth.currentUser.uid);
    const docSnap = await getDoc(userRef);
    const user_info = docSnap.data();
    console.log("[FETCH_USER_INFO] - DONE: ", user_info);
    dispatch({ type: "FETCH_USER_INFO", payload: user_info });
  };
};

export const setUserOnboardingStepLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_USER_ONBOARDING_STEP_LOCAL] : ", item);
    dispatch({ type: "SET_USER_ONBOARDING_STEP_LOCAL", payload: item });
  };
};
export const setUserOnboardingStep = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_USER_ONBOARDING_STEP]", item);
    const userRef = doc(db_firestore, "users", auth.currentUser.uid);
    const docSnap = await getDoc(userRef);
    let user_data;
    if (docSnap.exists()) {
      user_data = docSnap.data();
      user_data["usage_info"]["onboarding_step"] = item;
      // update remote
      await updateDoc(userRef, {
        usage_info: user_data["usage_info"],
      });
      console.log("[SET_USER_ONBOARDING_STEP] - DONE.");
      dispatch({ type: "SET_USER_ONBOARDING_STEP" });
    } else {
      console.log("[SET_USER_ONBOARDING_STEP] No such document!");
    }
  };
};

export const setUserInfoLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    const state = getState();
    const user_data = state.user.user_info;
    user_data["user_info"]["name"] = item.name;
    user_data["user_info"]["lastname"] = item.lastname;
    user_data["organization_info"]["position"] = item.position;
    console.log("[SET_USER_INFO_LOCAL] - RESULTS: ", user_data);
    dispatch({ type: "SET_USER_INFO_LOCAL", payload: user_data });
  };
};

export const updateUserInfo = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    const userRef = doc(db_firestore, "users", auth.currentUser.uid);
    const docSnap = await getDoc(userRef);
    let user_data;
    if (docSnap.exists()) {
      user_data = docSnap.data();
      user_data["user_info"]["name"] = item.name;
      user_data["user_info"]["lastname"] = item.lastname;
      user_data["organization_info"]["position"] = item.position;
      // update remote
      await updateDoc(userRef, user_data);
      dispatch({ type: "UPDATE_USER_INFO" });
    } else {
      console.log("[UPDATE_USER_INFO] No such document!");
    }
  };
};

export const addUserProfile = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_USER_PROFILE]", item);
    // firestore ref data
    let invited_by_user_id = auth.currentUser.uid;
    const userRef = doc(db_firestore, "users", invited_by_user_id);
    const docSnap = await getDoc(userRef);

    console.log("[ADD_USER_PROFILE docSnap]", docSnap);

    // get user_data
    let user_data;
    if (docSnap.exists()) {
      user_data = docSnap.data();
    } else {
      console.log("[addUserProfile] No such document!");
    }

    console.log("[ADD_USER_PROFILE user_data]", user_data);

    // functions input data
    const tenant_id = user_data.organization_info.tenant_id;
    const organization_id = user_data.organization_info.id;
    const user_email = item.user_email;
    const user_role = JSON.stringify(item.user_role);
    const env = process.env.REACT_APP_NODE_ENV;

    const orgRef = doc(db_firestore, "organization", organization_id);

    const orgSnap = await getDoc(orgRef);

    console.log("[ADD_USER_PROFILE orgSnap]", orgSnap);

    const organization_data = orgSnap.data();
    const organization_name = organization_data.organization_info.name;

    // call cloud function
    console.log("[START ADD USER PROFILE]: ", { tenant_id: tenant_id, organization_id: organization_id, user_email: user_email, user_role: user_role, invited_by_user_id: invited_by_user_id });

    let url;
    if (process.env.REACT_APP_NODE_ENV === "DEV") {
      // connect to local emulator for debug locally
      firebase.functions().useFunctionsEmulator("http://localhost:5001");
      url = "http://localhost:5001/lokalite-saas/us-central1/app/addUserProfile";
    } else {
      url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/addUserProfile";
    }

    await fetch(
      `${url}?tenant_id=${encodeURIComponent(tenant_id)}&organization_id=${encodeURIComponent(organization_id)}&organization_name=${encodeURIComponent(
        organization_name
      )}&user_email=${encodeURIComponent(user_email)}&user_role=${encodeURIComponent(user_role)}&invited_by_user_id=${encodeURIComponent(invited_by_user_id)}&env=${encodeURIComponent(env)}`
    )
      .then((response) => {
        return response.json();
      })
      .then(async (json) => {
        console.log("[addUserProfile sucess] - analysis_id: ", json);
        if (json.data && json.data.user_data && json.data.user_data.code === "auth/email-already-exists") {
          ToastWarn("Utilisateur déjà invité. Nouvelle email-invitation envoyé.");
        } else if (json.message === "auth/email-already-exists") {
          ToastWarn("Utilisateur déjà invité. Nouvelle email-invitation envoyé.");
        } else if (json.status === "success") {
          ToastSuccess("Email-invitation envoyé.");
        } else if (!(json.status === "success")) {
          console.log("PORMPTTT");
          ToastWarn(json.message ? json.message : "Something went wrong.");
        }
        dispatch({ type: "ADD_USER_PROFILE", paytheload: json });
      });

    // SEND LOGIN EMAIL [waiting for sengrid]
  };
};
export const updateUserProfile = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_USER_PROFILE]", item);
    const userRef = doc(db_firestore, "users", item.user_id);
    console.log("user_role", item);
    await updateDoc(userRef, {
      "organization_info.role": item.user_role,
    });
    console.log("[UPDATE_USER_PROFILE] - Done.");
    dispatch({ type: "UPDATE_USER_PROFILE", payload: item });
  };
};

export const updateUserProfileLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_USER_PROFILE_LOCAL]", item);
    dispatch({ type: "UPDATE_USER_PROFILE_LOCAL", payload: item });
  };
};

export const deleteUserProfileLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[DELETE_USER_PROFILE_LOCAL]");
    dispatch({ type: "DELETE_USER_PROFILE_LOCAL", payload: item.user_id });
  };
};

export const deleteUserProfile = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[DELETE_USER_PROFILE]");

    // call cloud function
    console.log("[START DELETE USER PROFILE]: ", item);

    let url;
    if (process.env.REACT_APP_NODE_ENV === "DEV") {
      // connect to local emulator for debug locally
      firebase.functions().useFunctionsEmulator("http://localhost:5001");
      url = "http://localhost:5001/lokalite-saas/us-central1/app/deleteUserProfile";
    } else {
      url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/deleteUserProfile";
    }

    await fetch(`${url}?tenant_id=${encodeURIComponent(item.tenant_id)}&organization_id=${encodeURIComponent(item.organization_id)}&user_id=${encodeURIComponent(item.user_id)}`)
      .then((response) => {
        return response.json();
      })
      .then(async (json) => {
        console.log("[DELETE_USER_PROFILE] - DONE:", json);
        if (json.data && json.data.is_delete_ok) {
          ToastSuccess("Utilisateur supprimé.");
        }
        dispatch({ type: "DELETE_USER_PROFILE", payload: json });
      });
  };
};

export const fetchAllUsers = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[START FETCH ALL USERS]");

    const tenant_id = auth.currentUser.tenantId;

    // let db = firebase.firestore();
    const usersRef = collection(db_firestore, "users");
    // create a query against the collection.
    const q = query(usersRef, where("organization_info.tenant_id", "==", tenant_id));
    const querySnapshot = await getDocs(q);
    console.log("query", querySnapshot, tenant_id);
    let users_data = [];
    querySnapshot.forEach((doc) => {
      // console.log("[FETCH_ORG_INFO] - found users", doc.id);
      users_data.push({ id: doc.id, data: doc.data() });
    });

    const data = Object.values(users_data).sort(function compare(a, b) {
      if (a.id === auth.currentUser.uid) {
        return -1;
      }
      if (b.id !== auth.currentUser.uid) {
        return 1;
      }
      return 0;
    });

    console.log("users_data", data, auth.currentUser.uid);

    dispatch({ type: "FETCH_ALL_USERS", payload: data });

    // firestore ref data
    // let db = firebase.firestore();
    // const usersRef = collection(db, "users");

    // usersRef.where("user");
    // const querySnapshot = await getDocs(usersRef);
    // let users_data = [];
    // querySnapshot.forEach((doc) => {
    //   // doc.data() is never undefined for query doc snapshots
    //   // console.log(doc.id, " => ", doc.data());
    //   users_data.push({ id: doc.id, data: doc.data() });
    // });

    // console.log(users_data);

    // SEND LOGIN EMAIL
  };
};

export const setAllUsers = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    dispatch({ type: "SET_ALL_USERS", payload: item });
  };
};

export const setFreeSubscriptionDaysLeft = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("SET_FREE_SUBSCRIPTION_DAYS_LEFT", item);
    dispatch({ type: "SET_FREE_SUBSCRIPTION_DAYS_LEFT", payload: item });
  };
};

export const getSubscriptionCheckoutUrl = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[GET_SUBSCRIPTION_CHECKOUT_URL]", item);

    const env = process.env.REACT_APP_NODE_ENV;
    console.log("env", JSON.stringify("DEV"), encodeURIComponent(JSON.stringify("DEV")));

    let url;
    await fetch(
      `https://us-central1-lokalite-saas.cloudfunctions.net/createStripeCheckoutSession?price_ids=${encodeURIComponent(JSON.stringify(item.price_ids))}
    &customer_id=${encodeURIComponent(JSON.stringify(item.customer_id))}
    &env=${encodeURIComponent(JSON.stringify(env))}`
      // { headers: headers,  }
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log("[GET_SUBSCRIPTION_CHECKOUT_URL success] - res: ", json);
        url = json.data.checkout_url;
        // if (json.status === 'success') {
        dispatch({ type: "GET_SUBSCRIPTION_CHECKOUT_URL", payload: item });
        // } else {
        //   dispatch({ type: "OPTIMIZATION_RUN", payload: "error" });
        // }
      });
    return url;
  };
};

export const getBillingManagementPortal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[GET_BILLING_MANGEMENT_URL]", item);

    const env = process.env.REACT_APP_NODE_ENV;

    let url;
    await fetch(
      `https://us-central1-lokalite-saas.cloudfunctions.net/getBillingManagementPortal?&customer_id=${encodeURIComponent(JSON.stringify(item.customer_id))}
    &env=${encodeURIComponent(JSON.stringify(env))}`
      // { headers: headers,  }
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log("[GET_BILLING_MANGEMENT_URL success] - res: ", json);
        url = json.data.billing_management_url;
        // if (json.status === 'success') {
        dispatch({ type: "GET_BILLING_MANGEMENT_URL" });
        // } else {
        //   dispatch({ type: "OPTIMIZATION_RUN", payload: "error" });
        // }
      });
    return url;
  };
};

export const updateSubscriptionItems = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[GET_BILLING_MANGEMENT_URL]", item);
    let results;
    await fetch(
      `https://us-central1-lokalite-saas.cloudfunctions.net/updateSubscriptionItems?&subscription_id=${encodeURIComponent(JSON.stringify(item.subscription_id))}
    &items=${encodeURIComponent(JSON.stringify(item.items))}`
      // { headers: headers,  }
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        console.log("[UPDATE_SUBSCRIPTION_ITEMS success] - res: ", json);
        // if (json.status === 'success') {
        results = json;
        dispatch({ type: "UPDATE_SUBSCRIPTION_ITEMS" });
        // } else {
        //   dispatch({ type: "OPTIMIZATION_RUN", payload: "error" });
        // }
      });
    return results;
  };
};

export const fetchProducts = () => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[FETCH_PRODUCTS]");

    let products = {};
    await db_firestore
      .collection("subscriptions")
      .where("active", "==", true)
      .get()
      .then(async (querySnapshot) => {
        // const products = {};
        await querySnapshot.docs.forEach(async (productDoc) => {
          products[productDoc.id] = productDoc.data();
          const priceSnapShot = await productDoc.ref.collection("prices").get();
          await priceSnapShot.forEach(async (priceDoc) => {
            products[productDoc.id].prices = {
              priceId: priceDoc.id,
              priceData: priceDoc.data(),
            };
          });
        });
      });
    console.log("[FETCH_PRODUCTS] - END", products);
    // products = Object.fromEntries(Object.entries(products).filter((x) => x[1].metadata && x[1].metadata.is_main_plan === "1" && !x[1].name.includes("Free")));
    dispatch({ type: "FETCH_PRODUCTS", payload: products });
  };
};

export const fetchSubscription = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[FETCH_SUBSCRIPTION]");

    let subscription = {};
    await db_firestore
      .collection("users")
      .doc(item.user_id)
      .collection("subscriptions")
      .get()
      .then(async (querySnapshot) => {
        // console.log("toto",querySnapshot.docs[0].exists);
        await querySnapshot.docs.forEach(async (subSnapshot) => {
          console.log("subSnapshot", subSnapshot.data());
          console.log("id", subSnapshot.id);
          subscription[subSnapshot.id] = subSnapshot.data();
        });
      });

    subscription = Object.fromEntries(Object.entries(subscription).filter((x) => !x[1].cancel_at_period_end));
    console.log("[FETCH_SUBSCRIPTION] - DONE:", subscription);

    dispatch({ type: "FETCH_SUBSCRIPTION", payload: Object.keys(subscription).length === 0 ? null : subscription });
  };
};

export const getFreeSubscriptionDaysLeft = (user_info) => {
  // return async (dispatch, getState, { getFirebase }) => {
  const creation_date = parseFloat(user_info.user_info.createdAt.seconds);
  console.log("creation_date", new Date(creation_date * 1000));
  const actual_date = new Date().getTime() / 1000;
  // const actual_date = new Date(1678001628*1000).getTime() / 1000;
  // console.log('actual_date', new Date(actual_date*1000))
  // console.log('actual_date', new Date(1678001628*1000))
  const current_period = (actual_date - creation_date) / (3600 * 24);
  console.log("++++current_period", 7 - current_period);
  if (user_info.organization_info.tenant_id === "ORGATEST-2qv0m") {
    return 20;
  } else {
    return 7 - parseFloat(current_period);
  }
};
